// src/components/ConfirmPopup.jsx
// 공용 확인 팝업 — 예/아니오. ←→로 포커스 이동, Enter/Space는 포커스된 버튼의
// 네이티브 동작 그대로 사용(중복 발동 방지), Esc = 아니오.
import React, { useEffect, useRef } from "react";
import styles from "./ConfirmPopup.module.css";

export default function ConfirmPopup({
  message,
  onConfirm,
  onCancel,
  confirmLabel = "예",
  cancelLabel = "아니오",
}) {
  const confirmRef = useRef(null);
  const cancelRef = useRef(null);

  useEffect(() => {
    confirmRef.current?.focus();
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        confirmRef.current?.focus();
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        cancelRef.current?.focus();
      } else if (e.key === "Escape") {
        e.preventDefault();
        onCancel();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onCancel]);

  return (
    <div className={styles.overlay}>
      <div className={styles.box} role="alertdialog" aria-modal="true">
        <div className={styles.message}>{message}</div>
        <div className={styles.buttonRow}>
          <button ref={confirmRef} type="button" className={styles.btnPrimary} onClick={onConfirm}>
            {confirmLabel}
          </button>
          <button ref={cancelRef} type="button" className={styles.btnSecondary} onClick={onCancel}>
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
